import { render } from "./VerticalLayout.vue?vue&type=template&id=c6d7197a&ts=true"
import script from "./VerticalLayout.vue?vue&type=script&lang=ts"
export * from "./VerticalLayout.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__